import { render, staticRenderFns } from "./reply-default.vue?vue&type=template&id=22fcb18a&scoped=true&"
import script from "./reply-default.vue?vue&type=script&lang=js&"
export * from "./reply-default.vue?vue&type=script&lang=js&"
import style0 from "./reply-default.vue?vue&type=style&index=0&id=22fcb18a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fcb18a",
  null
  
)

export default component.exports